module.exports = __webpack_public_path__ + "img/old2.aa9bcbaa.jpg";